module.exports = __webpack_public_path__ + "img/shop.95334c73.jpg";